import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import visaImage from "../../Images/visa.png";
import mastercardImage from "../../Images/mastercard.png";
import paypalImage from "../../Images/paypal2.png";
import americanexpressImage from "../../Images/american-express.png";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "../../Style/CreateInvoice.css";
import "../../Style/Print.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toWords } from "number-to-words";
import { path_url } from "../../Config/config";
import axios from "axios";
import ESign from "../../Utils/ESign";
import QuotationGenerateFromPOModal from "../../components/Quotation/QuotationGenerateFromPOModal";

const DEFAULT_PRODUCT_OPTIONS = [
  { value: "sample-1", label: "Consulting Services", hsnCode: "9983", uom: "HRS", rate: 2500, discount: 0, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-2", label: "Software License (Annual)", hsnCode: "9973", uom: "NOS", rate: 45000, discount: 5, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-3", label: "Server Infrastructure Setup", hsnCode: "9987", uom: "SET", rate: 30000, discount: 0, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-4", label: "Hardware Equipment A", hsnCode: "8471", uom: "PCS", rate: 55000, discount: 10, cgst: 9, sgst: 9, igst: 0 },
  { value: "sample-5", label: "Maintenance & Support", hsnCode: "9987", uom: "MTH", rate: 8000, discount: 0, cgst: 9, sgst: 9, igst: 0 },
];

const CURRENCY_OPTIONS = [
  { value: "INR", label: "INR (₹)", symbol: "₹" },
  { value: "USD", label: "USD ($)", symbol: "$" },
  { value: "EUR", label: "EUR (€)", symbol: "€" },
  { value: "GBP", label: "GBP (£)", symbol: "£" },
];

const customDropdownStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  menu: (base) => ({
    ...base,
    zIndex: 99999,
    minWidth: "220px",
    borderRadius: "8px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
    border: "1px solid #e2e5ec",
    padding: "4px",
    textAlign: "left",
  }),
  control: (base, state) => ({
    ...base,
    minHeight: "36px",
    height: "36px",
    borderRadius: "6px",
    borderColor: state.isFocused ? "#7b55ff" : "#e2e5ec",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(123, 85, 255, 0.15)" : "none",
    "&:hover": { borderColor: "#7b55ff" },
    fontSize: "0.85rem",
    backgroundColor: "#fff",
    textAlign: "left",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    backgroundColor: state.isSelected
      ? "#7b55ff"
      : state.isFocused
        ? "#f3f0ff"
        : "#fff",
    color: state.isSelected ? "#fff" : "#2b2d3a",
    fontSize: "0.85rem",
    borderRadius: "4px",
    cursor: "pointer",
    padding: "6px 10px",
  }),
  singleValue: (base) => ({
    ...base,
    textAlign: "left",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "0 8px",
    textAlign: "left",
  }),
};

const statusDropdownStyles = {
  ...customDropdownStyles,
  menu: (base) => ({
    ...base,
    zIndex: 99999,
    width: "100%",
    minWidth: "100%",
    left: 0,
    right: 0,
    borderRadius: "8px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
    border: "1px solid #e2e5ec",
    padding: "4px",
    textAlign: "left",
  }),
  option: (base, state) => ({
    ...base,
    textAlign: "left",
    backgroundColor: state.isSelected
      ? "#7b55ff"
      : state.isFocused
        ? "#f3f0ff"
        : "#fff",
    color: state.isSelected ? "#fff" : "#2b2d3a",
    fontSize: "0.85rem",
    borderRadius: "4px",
    cursor: "pointer",
    padding: "6px 12px",
  }),
  singleValue: (base) => ({
    ...base,
    textAlign: "left",
  }),
};

const CreateQuotation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [showGenModal, setShowGenModal] = useState(false);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const columnNames = [
    "S. No.",
    "Product Description",
    "HSN code",
    "UOM",
    "Qty",
    "Rate",
    "Amount",
    "Discount",
    "Taxable Value",
    "CGST Rate",
    "CGST Amount",
    "SGST Rate",
    "SGST Amount",
    "IGST Rate",
    "IGST Amount",
    "Total",
  ];

  const [rows, setRows] = useState([]);
  const [totalSubtotal, setTotalSubtotal] = useState(0);
  const [totalGrandtotal, setTotalGrandtotal] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [tax, setTax] = useState({
    cgstTax: 0,
    sgstTax: 0,
    igstTax: 0,
  });
  const [amountInWords, setAmountInWords] = useState("");
  const [packingCharges, setPackingCharges] = useState(0);
  const [freight, setFreight] = useState(0);
  const [insurance, setInsurance] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [vendorId, setVendorId] = useState(null);

  // Seller / Company
  const [senderData, setSenderData] = useState({
    name: "",
    address: "",
    gstin: "",
    state: "",
    code: "",
  });

  // Buyer / Client / Recipient
  const [receiverData, setReceiverData] = useState({
    name: "",
    address: "",
    gstin: "",
    state: "",
    code: "",
  });

  useEffect(() => {
    // Keep recipient fields blank by default as requested
    if (location.state?.vendorId) {
      setVendorId(location.state.vendorId);
    }
  }, [location.state]);

  const [quoteDetails, setQuoteDetails] = useState({
    quoteNo: `QT-${Date.now().toString().slice(-4)}`,
    quoteDate: new Date(),
    validUntil: new Date(Date.now() + 15 * 24 * 60 * 60 * 1000),
    status: { value: "Draft", label: "Draft" },
    currency: { value: "INR", label: "INR (₹)", symbol: "₹" },
    terms: "Quotation is valid for 15 days. Payment terms: 50% advance, balance on delivery.",
  });

  const currentCurrencySymbol = quoteDetails.currency?.symbol || "₹";

  const getCurrencyWord = (currVal) => {
    switch (currVal) {
      case "USD":
        return "US DOLLARS ONLY";
      case "EUR":
        return "EUROS ONLY";
      case "GBP":
        return "POUNDS ONLY";
      default:
        return "RUPEES ONLY";
    }
  };

  const statusOptions = [
    { value: "Draft", label: "Draft" },
    { value: "Sent", label: "Sent" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  const [bankDetails, setBankDetails] = useState({
    bankName: "",
    bankAccNo: "",
    bankIFSC: "",
    termsAndConditions: "1. All prices are in specified currency.\n2. Goods once sold will not be returned.\n3. Subject to local jurisdiction.",
  });

  // ESign Modal state
  const [lgShow, setLgShow] = useState(false);
  const sigCanvasRef = useRef(null);

  const handleESignModal = () => setLgShow(true);
  const handleCloseModal = () => setLgShow(false);

  const handleSenderDataChange = (e) => {
    const { name, value } = e.target;
    setSenderData((prev) => ({ ...prev, [name]: value }));
  };

  const handleReceiverDataChange = (e) => {
    const { name, value } = e.target;
    setReceiverData((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuoteDetailsChange = (name, value) => {
    setQuoteDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prev) => ({ ...prev, [name]: value }));
  };

  // Helper calculation logic
  const recalculateTotals = (currentRows, pCharges = packingCharges, fCharges = freight, iCharges = insurance) => {
    let sub = 0;
    let cgstSum = 0;
    let sgstSum = 0;
    let igstSum = 0;

    currentRows.forEach((r) => {
      sub += Number(r["Taxable Value"]) || 0;
      cgstSum += Number(r["CGST Amount"]) || 0;
      sgstSum += Number(r["SGST Amount"]) || 0;
      igstSum += Number(r["IGST Amount"]) || 0;
    });

    const taxTotal = cgstSum + sgstSum + igstSum;
    const grand = sub + taxTotal + Number(pCharges || 0) + Number(fCharges || 0) + Number(iCharges || 0);

    setTotalSubtotal(sub);
    setTax({
      cgstTax: cgstSum,
      sgstTax: sgstSum,
      igstTax: igstSum,
    });
    setTotalTax(taxTotal);
    setTotalGrandtotal(grand);

    try {
      if (grand > 0) {
        setAmountInWords(toWords(Math.round(grand)).toUpperCase() + " " + getCurrencyWord(quoteDetails.currency?.value));
      } else {
        const curr = quoteDetails.currency?.value;
        const zeroWord = curr === "USD" ? "ZERO DOLLARS" : curr === "EUR" ? "ZERO EUROS" : curr === "GBP" ? "ZERO POUNDS" : "ZERO RUPEES";
        setAmountInWords(zeroWord);
      }
    } catch (e) {
      setAmountInWords("");
    }
  };

  useEffect(() => {
    if (totalGrandtotal > 0) {
      try {
        setAmountInWords(
          toWords(Math.round(totalGrandtotal)).toUpperCase() + " " + getCurrencyWord(quoteDetails.currency?.value)
        );
      } catch (e) {
        setAmountInWords("");
      }
    }
  }, [quoteDetails.currency, totalGrandtotal]);

  const handleRowChange = (index, field, value) => {
    const updated = [...rows];
    const row = { ...updated[index] };

    if (field === "Product Description") {
      row["Product Description"] = value;
      if (value && typeof value === "object") {
        row["HSN code"] = value.hsnCode || "";
        row.UOM = value.uom || "PCS";
        row.Rate = Number(value.rate) || 0;
        row.Discount = Number(value.discount) || 0;
        row["CGST Rate"] = Number(value.cgst) || 0;
        row["SGST Rate"] = Number(value.sgst) || 0;
        row["IGST Rate"] = Number(value.igst) || 0;
      }
    } else {
      row[field] = value;
    }

    const qty = Number(row.Qty) || 0;
    const rate = Number(row.Rate) || 0;
    const amount = qty * rate;
    const discount = Number(row.Discount) || 0;
    const discountAmount = (amount * discount) / 100;
    const taxableValue = Math.max(0, amount - discountAmount);

    const cgstRate = Number(row["CGST Rate"]) || 0;
    const sgstRate = Number(row["SGST Rate"]) || 0;
    const igstRate = Number(row["IGST Rate"]) || 0;

    const cgstAmount = (taxableValue * cgstRate) / 100;
    const sgstAmount = (taxableValue * sgstRate) / 100;
    const igstAmount = (taxableValue * igstRate) / 100;

    const total = taxableValue + cgstAmount + sgstAmount + igstAmount;

    row.Amount = amount;
    row["Taxable Value"] = taxableValue;
    row["CGST Amount"] = cgstAmount;
    row["SGST Amount"] = sgstAmount;
    row["IGST Amount"] = igstAmount;
    row.Total = total;

    updated[index] = row;
    setRows(updated);
    recalculateTotals(updated);
  };

  const handleAddRow = () => {
    const newRow = {
      "S. No.": rows.length + 1,
      "Product Description": null,
      "HSN code": "",
      UOM: "PCS",
      Qty: 1,
      Rate: 0,
      Amount: 0,
      Discount: 0,
      "Taxable Value": 0,
      "CGST Rate": 9,
      "CGST Amount": 0,
      "SGST Rate": 9,
      "SGST Amount": 0,
      "IGST Rate": 0,
      "IGST Amount": 0,
      Total: 0,
    };
    const updated = [...rows, newRow];
    setRows(updated);
    recalculateTotals(updated);
  };

  const handleDeleteRow = (index) => {
    if (rows.length <= 1) {
      toast.warn("Quotation must have at least one product row.");
      return;
    }
    const updated = rows.filter((_, i) => i !== index).map((r, i) => ({ ...r, "S. No.": i + 1 }));
    setRows(updated);
    recalculateTotals(updated);
  };

  // Initial load default row & products
  useEffect(() => {
    if (rows.length === 0) {
      const initialRow = {
        "S. No.": 1,
        "Product Description": DEFAULT_PRODUCT_OPTIONS[0],
        "HSN code": DEFAULT_PRODUCT_OPTIONS[0].hsnCode,
        UOM: DEFAULT_PRODUCT_OPTIONS[0].uom,
        Qty: 2,
        Rate: DEFAULT_PRODUCT_OPTIONS[0].rate,
        Amount: DEFAULT_PRODUCT_OPTIONS[0].rate * 2,
        Discount: 0,
        "Taxable Value": DEFAULT_PRODUCT_OPTIONS[0].rate * 2,
        "CGST Rate": 9,
        "CGST Amount": (DEFAULT_PRODUCT_OPTIONS[0].rate * 2 * 9) / 100,
        "SGST Rate": 9,
        "SGST Amount": (DEFAULT_PRODUCT_OPTIONS[0].rate * 2 * 9) / 100,
        "IGST Rate": 0,
        "IGST Amount": 0,
        Total: (DEFAULT_PRODUCT_OPTIONS[0].rate * 2) * 1.18,
      };
      const initialRows = [initialRow];
      setRows(initialRows);
      recalculateTotals(initialRows);
    }
  }, []);

  // Fetch products and company/vendor data
  const [productData, setProductData] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId");
      if (!token || !adminId) return;

      try {
        const productRes = await axios.get(`${path_url}/product/invoice/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setProductData(productRes.data || []);
      } catch (error) {
        console.error("Error fetching products:", error);
      }

      try {
        const vendorRes = await axios.get(`${path_url}/vendor/dashboard/${adminId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setVendorList(vendorRes.data || []);
      } catch (err) {
        console.error("Error fetching vendors:", err);
      }
    };

    fetchData();
  }, []);

  const productOptions =
    productData && productData.length > 0
      ? productData.map((item) => ({
        value: item.id || item.productid,
        label: item.productname || item.name || "Product",
        hsnCode: item.hsnCode || item.hsncode || item.hsn || "",
        uom: item.unitmeasure || item.uom || "PCS",
        rate: Number(item.sellingprice || item.rate || item.price || 0),
        discount: Number(item.discount || 0),
        cgst: Number(item.cgstRate || item.cgst || 9),
        sgst: Number(item.sgstRate || item.sgst || 9),
        igst: Number(item.igstRate || item.igst || 0),
      }))
      : DEFAULT_PRODUCT_OPTIONS;

  // Helper to ensure vendor with address is created if needed
  const createVendorWithAddress = async (token, usercid, adminId) => {
    try {
      const vendorName = receiverData.name || "Client Recipient";
      const nameParts = vendorName.trim().split(" ");
      const firstName = nameParts[0] || "Client";
      const lastName = nameParts.slice(1).join(" ") || "Customer";

      const vendorPayload = {
        firstname: firstName,
        lastname: lastName,
        companyname: vendorName,
        mobile: "9876543210",
        email: `${firstName.toLowerCase().replace(/[^a-z0-9]/g, "")}_${Date.now()}@client.com`,
        gstnumber: receiverData.gstin || "",
        address1: receiverData.address || "Industrial Area, Sector 5",
        address2: "",
        city: (receiverData.address || "City").split(",")[0].trim() || "City",
        state: receiverData.state || "Delhi",
        country: "India",
        pincode: parseInt(receiverData.code) || 110001,
        status: "OPEN",
        leadsource: "Quotation",
        usercid: usercid || adminId,
        useradminid: adminId,
        owner: adminId,
      };

      console.log("Creating vendor/client with payload:", vendorPayload);
      const vRes = await axios.post(`${path_url}/vendor`, vendorPayload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const createdVId =
        vRes.data?.body?.id ||
        vRes.data?.body?.vendor?.id ||
        vRes.data?.id ||
        vRes.data?.vendor?.id;

      if (createdVId) {
        console.log("Created vendor ID:", createdVId);

        const billingPayload = {
          vendorid: createdVId,
          active: true,
          name: receiverData.name || "Billing Address",
          Address1: receiverData.address || "Industrial Area, Sector 5",
          address1: receiverData.address || "Industrial Area, Sector 5",
          Address2: "",
          address2: "",
          City: (receiverData.address || "City").split(",")[0].trim() || "City",
          city: (receiverData.address || "City").split(",")[0].trim() || "City",
          State: receiverData.state || "Delhi",
          state: receiverData.state || "Delhi",
          Pincode: parseInt(receiverData.code) || 110001,
          pincode: parseInt(receiverData.code) || 110001,
          Country: "India",
          country: "India",
          useradminid: adminId,
          usercid: usercid,
        };
        await axios.post(`${path_url}/vendor/billingaddress`, billingPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }).catch((e) => console.warn("Vendor billing address info:", e?.response?.status));

        const shippingPayload = {
          vendorid: createdVId,
          active: true,
          name: senderData.name || "Shipping Address",
          Address1: senderData.address || "Vijay Nagar, Sector 62",
          address1: senderData.address || "Vijay Nagar, Sector 62",
          Address2: "",
          address2: "",
          City: (senderData.address || "Noida").split(",")[0].trim() || "Noida",
          city: (senderData.address || "Noida").split(",")[0].trim() || "Noida",
          State: senderData.state || "Uttar Pradesh",
          state: senderData.state || "Uttar Pradesh",
          Pincode: parseInt(senderData.code) || 201301,
          pincode: parseInt(senderData.code) || 201301,
          Country: "India",
          country: "India",
          useradminid: adminId,
          usercid: usercid,
        };
        await axios.post(`${path_url}/vendor/shippingaddress`, shippingPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }).catch((e) => console.warn("Vendor shipping address info:", e?.response?.status));

        return createdVId;
      }
      return null;
    } catch (err) {
      console.error("Error creating vendor with address:", err);
      return null;
    }
  };

  // Save Quotation
  const handleSaveQuotation = async () => {
    const token = localStorage.getItem("accessToken");
    const usercid =
      localStorage.getItem("userId") ||
      localStorage.getItem("adminId") ||
      localStorage.getItem("usercid");
    const adminId = localStorage.getItem("adminId");

    if (!token) {
      toast.error("You are not logged in. Please login first.");
      return;
    }

    setIsSaving(true);
    try {
      let targetVendorId = vendorId;

      if (!targetVendorId && vendorList && vendorList.length > 0) {
        const matchingVendor = vendorList.find(
          (v) =>
            (receiverData.name && v.companyname && v.companyname.toLowerCase() === receiverData.name.toLowerCase()) ||
            (receiverData.name && v.firstname && `${v.firstname} ${v.lastname || ""}`.trim().toLowerCase() === receiverData.name.toLowerCase())
        );
        if (matchingVendor) {
          targetVendorId = matchingVendor.id;
          setVendorId(targetVendorId);
        }
      }

      if (!targetVendorId) {
        targetVendorId = await createVendorWithAddress(token, usercid, adminId);
        if (targetVendorId) {
          setVendorId(targetVendorId);
        } else if (vendorList && vendorList.length > 0) {
          targetVendorId = vendorList[0].id;
        }
      }

      if (!targetVendorId) {
        toast.error("Please provide client/vendor details to save quotation.");
        setIsSaving(false);
        return;
      }

      // Step 1: Create a base PO to connect directly with the backend Quotation Engine
      const poPayload = {
        status: "New",
        vendorid: targetVendorId,
        usercid: usercid,
        useradminid: adminId,
        subject: `Quotation - ${quoteDetails.quoteNo}`,
        PONumber: `QT-${Date.now().toString().slice(-6)}`,
        duedate: quoteDetails.validUntil ? quoteDetails.validUntil.toISOString().split("T")[0] : null,
        priority: "Normal",
        groupCategory: "Sales",
        totalPOamount: totalGrandtotal || 0,
        totalcgst: tax.cgstTax || 0,
        totalsgst: tax.sgstTax || 0,
        totaligst: tax.igstTax || 0,
        totalpaidamount: 0,
        dueAmount: totalGrandtotal || 0,
        amountinwords: amountInWords || "Zero",
        PONotes: bankDetails.termsAndConditions || "",
        taxType: "Master",
        editMode: true,
        editedBy: usercid,
        owner: usercid,
        asignedto: usercid,
      };

      console.group("🚀 [API CALL] Saving Quotation via Backend Pipeline");
      console.log("Saving base PO payload:", poPayload);

      let poResponse;
      try {
        poResponse = await axios.post(`${path_url}/po`, poPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      } catch (firstErr) {
        const errMsg = (
          firstErr?.response?.data?.message ||
          firstErr?.response?.data?.error ||
          (typeof firstErr?.response?.data === "string" ? firstErr.response.data : "") ||
          firstErr?.message ||
          ""
        ).toLowerCase();

        if (errMsg.includes("address") || errMsg.includes("vendor") || errMsg.includes("billing") || errMsg.includes("shipping")) {
          const newVendorId = await createVendorWithAddress(token, usercid, adminId);
          if (newVendorId) {
            poPayload.vendorid = newVendorId;
            targetVendorId = newVendorId;
            setVendorId(newVendorId);
            poResponse = await axios.post(`${path_url}/po`, poPayload, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
          } else {
            throw firstErr;
          }
        } else {
          throw firstErr;
        }
      }

      const poId =
        poResponse?.data?.body?.purchaseOrder?.id ||
        poResponse?.data?.purchaseOrder?.id ||
        poResponse?.data?.body?.id ||
        poResponse?.data?.id ||
        poResponse?.data?.body?.poid ||
        poResponse?.data?.poid;

      if (!poId) {
        console.error("PO Response structure:", poResponse?.data);
        throw new Error("Failed to retrieve Purchase Order ID from backend response.");
      }

      console.log("✅ PO created with ID:", poId);

      // Step 2: Save line items to /po/items
      const isValidUUID = (str) =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(str);

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];
        const rawProdId = row["Product Description"]?.value;
        const validProdId = isValidUUID(rawProdId) ? rawProdId : null;

        const itemPayload = {
          poid: poId,
          vendorid: targetVendorId,
          productid: validProdId,
          productname:
            typeof row["Product Description"] === "object"
              ? row["Product Description"]?.label || "Product"
              : row["Product Description"] || "Product",
          unitMeasure: row.UOM || "PCS",
          sellingprice: Number(row.Rate) || 0,
          igstrate: Number(row["IGST Rate"]) || 0,
          sgstrate: Number(row["SGST Rate"]) || 0,
          cgstrate: Number(row["CGST Rate"]) || 0,
          quantity: Number(row.Qty) || 1,
          hsnCode: row["HSN code"] || "",
          discountPercentage: Number(row.Discount) || 0,
          discount: 0,
          discountPercentageEnabled: true,
          usercid: usercid,
          useradminid: adminId,
        };

        try {
          await axios.post(`${path_url}/po/items`, itemPayload, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
        } catch (itemErr) {
          console.warn("Item save note:", itemErr?.response?.status, itemErr?.message);
        }
      }

      // Step 3: Ensure PO Product Total exists
      const totalPayload = {
        poid: poId,
        vendorid: targetVendorId,
        totalQty: rows.reduce((acc, r) => acc + (Number(r.Qty) || 0), 0),
        totalAmount: totalSubtotal,
        totalDiscount: 0,
        totalTaxableValue: totalSubtotal,
        totalCGSTAmount: tax.cgstTax || 0,
        totalSGSTAmount: tax.sgstTax || 0,
        totalIGSTAmount: tax.igstTax || 0,
        totalAmountValue: totalGrandtotal,
        purchaseOrderTotalAmountBfrTx: totalSubtotal,
        purchaseOrderTotalCGSTValue: tax.cgstTax || 0,
        purchaseOrderTotalSGSTValue: tax.sgstTax || 0,
        purchaseOrderTotalIGSTValue: tax.igstTax || 0,
        purchaseOrderTotaltxAmount: totalTax,
        purchaseOrderTotalAmtAftrTx: totalGrandtotal,
        usercid: usercid,
        useradminid: adminId,
      };

      try {
        await axios.post(`${path_url}/po/producttotal`, totalPayload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
      } catch (totErr) {
        console.warn("Product total note:", totErr?.response?.status);
      }

      // Step 4: Call generate quotation from PO
      console.log(`📡 [API CALL] POST ${path_url}/quotation/generate-from-po/${poId}`);
      const quoteRes = await axios.post(
        `${path_url}/quotation/generate-from-po/${poId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("✅ [API RESPONSE] Quotation created successfully:", quoteRes.data);
      console.groupEnd();

      const createdQuote = quoteRes.data?.body || quoteRes.data;
      const quoteId = createdQuote?.id;

      toast.success(`Quotation ${createdQuote?.quoteNumber || ""} created successfully!`);

      setTimeout(() => {
        if (quoteId) {
          navigate(`/quotations/${quoteId}`);
        } else {
          navigate("/quotations");
        }
      }, 1000);

    } catch (error) {
      console.error("❌ [API ERROR] Error saving quotation:", error);
      const errMsg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        (typeof error?.response?.data === "string" ? error.response.data : null) ||
        error?.message ||
        "Failed to save quotation. Please verify your backend connection.";
      toast.error(errMsg);
    } finally {
      setIsSaving(false);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div>
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            isRightMenu={isRightMenu}
            setisRightMenu={setisRightMenu}
            handelRightMenuShow={handelRightMenuShow}
            isSearchShow={isSearchShow}
            setIsSearchShow={setIsSearchShow}
            handelShow={handelShow}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
          />
          <ToastContainer />
          <div className="content-wrapper pt-3">
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    {/* Main Quotation Sheet */}
                    <div className="invoice p-4 mb-3" style={{ borderRadius: "12px", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: "1px solid #e2e8f0" }}>
                      <div className="row mb-3 align-items-center">
                        <div className="col-lg-5 d-flex align-items-center gap-3 flex-wrap">
                          <h4 style={{ color: "#4f46e5", fontWeight: "700", margin: 0, fontSize: "1.3rem" }}>
                            <i className="fas fa-file-signature me-2" />
                            QUOTATION / ESTIMATE
                          </h4>
                          <div className="d-flex gap-2">
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => setShowGenModal(true)}
                              style={{ borderRadius: "8px", fontWeight: "600", fontSize: "0.82rem" }}
                            >
                              <i className="fas fa-file-import me-1" /> Import from PO
                            </button>
                            <Link
                              to="/quotations"
                              className="btn btn-outline-secondary btn-sm"
                              style={{ borderRadius: "8px", fontSize: "0.82rem" }}
                            >
                              <i className="fas fa-list me-1" /> Quotations List
                            </Link>
                          </div>
                        </div>
                        <div className="col-lg-7 text-lg-end d-flex justify-content-lg-end align-items-center gap-3 flex-wrap mt-2 mt-lg-0">
                          <div>
                            <span className="text-muted small d-block text-start">Quote Date:</span>
                            <DatePicker
                              className="form-control form-control-sm border"
                              selected={quoteDetails.quoteDate}
                              onChange={(d) => handleQuoteDetailsChange("quoteDate", d)}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                          <div>
                            <span className="text-muted small d-block text-start">Valid Until:</span>
                            <DatePicker
                              className="form-control form-control-sm border"
                              selected={quoteDetails.validUntil}
                              onChange={(d) => handleQuoteDetailsChange("validUntil", d)}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                          <div style={{ width: "140px", textAlign: "left" }}>
                            <span className="text-muted small d-block text-start">Status:</span>
                            <Select
                              value={quoteDetails.status}
                              onChange={(s) => handleQuoteDetailsChange("status", s)}
                              options={statusOptions}
                              styles={statusDropdownStyles}
                              isSearchable={false}
                            />
                          </div>
                        </div>
                      </div>

                      <hr className="my-3" />

                      {/* Addresses Row */}
                      <div className="row g-3 mb-4">
                        {/* Sender (Seller / Our Company) */}
                        <div className="col-md-4">
                          <div
                            style={{
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "10px",
                              padding: "16px",
                              height: "100%",
                              boxSizing: "border-box",
                            }}
                          >
                            <strong className="text-primary mb-3 d-block" style={{ fontSize: "0.92rem" }}>
                              <i className="fas fa-building me-1" /> From (Seller / Organization):
                            </strong>
                            <div className="mb-2">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Company / Seller Name"
                                name="name"
                                value={senderData.name}
                                onChange={handleSenderDataChange}
                              />
                            </div>
                            <div className="mb-2">
                              <textarea
                                className="form-control form-control-sm"
                                placeholder="Office Address"
                                rows="2"
                                name="address"
                                value={senderData.address}
                                onChange={handleSenderDataChange}
                              />
                            </div>
                            <div className="mb-2">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="GSTIN"
                                name="gstin"
                                value={senderData.gstin}
                                onChange={handleSenderDataChange}
                              />
                            </div>
                            <div>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="State"
                                name="state"
                                value={senderData.state}
                                onChange={handleSenderDataChange}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Receiver (Client / Customer / Vendor) */}
                        <div className="col-md-4">
                          <div
                            style={{
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "10px",
                              padding: "16px",
                              height: "100%",
                              boxSizing: "border-box",
                            }}
                          >
                            <strong className="text-success mb-3 d-block" style={{ fontSize: "0.92rem" }}>
                              <i className="fas fa-user me-1" /> To (Client / Customer):
                            </strong>
                            <div className="mb-2">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Client / Company Name"
                                name="name"
                                value={receiverData.name}
                                onChange={handleReceiverDataChange}
                              />
                            </div>
                            <div className="mb-2">
                              <textarea
                                className="form-control form-control-sm"
                                placeholder="Billing / Delivery Address"
                                rows="2"
                                name="address"
                                value={receiverData.address}
                                onChange={handleReceiverDataChange}
                              />
                            </div>
                            <div className="mb-2">
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="GSTIN"
                                name="gstin"
                                value={receiverData.gstin}
                                onChange={handleReceiverDataChange}
                              />
                            </div>
                            <div>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Pincode / Code"
                                name="code"
                                value={receiverData.code}
                                onChange={handleReceiverDataChange}
                              />
                            </div>
                          </div>
                        </div>

                        {/* Quotation Metadata */}
                        <div className="col-md-4">
                          <div
                            style={{
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "10px",
                              padding: "16px",
                              height: "100%",
                              boxSizing: "border-box",
                            }}
                          >
                            <strong className="text-secondary mb-3 d-block" style={{ fontSize: "0.92rem" }}>
                              <i className="fas fa-info-circle me-1" /> Quotation Details:
                            </strong>
                            <div className="mb-3">
                              <label className="small text-muted mb-1 d-block">Quote Reference #:</label>
                              <input
                                type="text"
                                className="form-control form-control-sm font-monospace fw-bold"
                                value={quoteDetails.quoteNo}
                                onChange={(e) => handleQuoteDetailsChange("quoteNo", e.target.value)}
                              />
                            </div>
                            <div className="mb-2" style={{ textAlign: "left" }}>
                              <label className="small text-muted mb-1 d-block">Currency:</label>
                              <Select
                                value={quoteDetails.currency}
                                onChange={(c) => handleQuoteDetailsChange("currency", c)}
                                options={CURRENCY_OPTIONS}
                                styles={statusDropdownStyles}
                                isSearchable={false}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Items Table */}
                      <div className="row">
                        <div className="col-12 table-responsive">
                          <table className="table table-bordered table-sm text-center align-middle" style={{ fontSize: "0.85rem" }}>
                            <thead className="table-light">
                              <tr>
                                {columnNames.map((col, idx) => (
                                  <th key={idx} style={{ whiteSpace: "nowrap" }}>
                                    {col}
                                  </th>
                                ))}
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {rows.map((row, idx) => (
                                <tr key={idx}>
                                  <td>{row["S. No."]}</td>
                                  <td style={{ minWidth: "220px", textAlign: "left" }}>
                                    <CreatableSelect
                                      value={row["Product Description"]}
                                      onChange={(selected) =>
                                        handleRowChange(idx, "Product Description", selected)
                                      }
                                      options={productOptions}
                                      styles={customDropdownStyles}
                                      placeholder="Select or type product..."
                                      isClearable
                                    />
                                  </td>
                                  <td style={{ width: "90px" }}>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-center"
                                      value={row["HSN code"]}
                                      onChange={(e) => handleRowChange(idx, "HSN code", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "80px" }}>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm text-center"
                                      value={row.UOM}
                                      onChange={(e) => handleRowChange(idx, "UOM", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "80px" }}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center"
                                      min="1"
                                      value={row.Qty}
                                      onChange={(e) => handleRowChange(idx, "Qty", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "100px" }}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center"
                                      min="0"
                                      value={row.Rate}
                                      onChange={(e) => handleRowChange(idx, "Rate", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "100px", fontWeight: "600" }}>
                                    {currentCurrencySymbol}{Number(row.Amount || 0).toLocaleString()}
                                  </td>
                                  <td style={{ width: "70px" }}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center"
                                      min="0"
                                      max="100"
                                      value={row.Discount}
                                      onChange={(e) => handleRowChange(idx, "Discount", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "100px", fontWeight: "600" }}>
                                    {currentCurrencySymbol}{Number(row["Taxable Value"] || 0).toLocaleString()}
                                  </td>
                                  <td style={{ width: "70px" }}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center"
                                      value={row["CGST Rate"]}
                                      onChange={(e) => handleRowChange(idx, "CGST Rate", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "85px" }}>
                                    {currentCurrencySymbol}{Number(row["CGST Amount"] || 0).toFixed(2)}
                                  </td>
                                  <td style={{ width: "70px" }}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center"
                                      value={row["SGST Rate"]}
                                      onChange={(e) => handleRowChange(idx, "SGST Rate", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "85px" }}>
                                    {currentCurrencySymbol}{Number(row["SGST Amount"] || 0).toFixed(2)}
                                  </td>
                                  <td style={{ width: "70px" }}>
                                    <input
                                      type="number"
                                      className="form-control form-control-sm text-center"
                                      value={row["IGST Rate"]}
                                      onChange={(e) => handleRowChange(idx, "IGST Rate", e.target.value)}
                                    />
                                  </td>
                                  <td style={{ width: "85px" }}>
                                    {currentCurrencySymbol}{Number(row["IGST Amount"] || 0).toFixed(2)}
                                  </td>
                                  <td style={{ width: "110px", fontWeight: "700", color: "#4f46e5" }}>
                                    {currentCurrencySymbol}{Number(row.Total || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-outline-danger btn-sm p-1"
                                      onClick={() => handleDeleteRow(idx)}
                                      title="Delete Row"
                                    >
                                      <i className="fas fa-trash-alt" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <button
                            type="button"
                            className="btn btn-outline-success btn-sm mb-3"
                            onClick={handleAddRow}
                          >
                            <i className="fas fa-plus me-1" /> Add Product Item
                          </button>
                        </div>
                      </div>

                      {/* Totals and Bank Details */}
                      <div className="row mt-3">
                        <div className="col-6">
                          <p className="lead">Terms & Instructions:</p>
                          <textarea
                            className="form-control mb-3"
                            rows="3"
                            name="termsAndConditions"
                            value={bankDetails.termsAndConditions}
                            onChange={handleBankDetailsChange}
                            placeholder="Enter terms, conditions, payment clauses..."
                          />

                          <div className="card p-2 bg-light">
                            <span className="small text-muted fw-bold">Amount in Words:</span>
                            <span className="fw-semibold text-dark">{amountInWords}</span>
                          </div>
                        </div>

                        <div className="col-6">
                          <p className="lead">Quotation Summary</p>
                          <div className="table-responsive">
                            <table className="table table-sm">
                              <tbody>
                                <tr>
                                  <th style={{ width: "50%" }}>Subtotal (Taxable):</th>
                                  <td className="text-end">{currentCurrencySymbol}{totalSubtotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                </tr>
                                <tr>
                                  <th>CGST Total:</th>
                                  <td className="text-end">{currentCurrencySymbol}{tax.cgstTax.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                </tr>
                                <tr>
                                  <th>SGST Total:</th>
                                  <td className="text-end">{currentCurrencySymbol}{tax.sgstTax.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                </tr>
                                {tax.igstTax > 0 && (
                                  <tr>
                                    <th>IGST Total:</th>
                                    <td className="text-end">{currentCurrencySymbol}{tax.igstTax.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                  </tr>
                                )}
                                <tr className="table-active">
                                  <th style={{ fontSize: "1.1rem" }}>Grand Total:</th>
                                  <td className="text-end fw-bold" style={{ fontSize: "1.1rem", color: "#4f46e5" }}>
                                    {currentCurrencySymbol}{totalGrandtotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      {/* Buttons */}
                      <div className="row no-print mt-4">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => navigate("/quotations")}
                          >
                            <i className="fas fa-arrow-left me-1" /> Back to Quotations
                          </button>
                          <div className="d-flex gap-2">
                            <button
                              type="button"
                              className="btn btn-default border"
                              onClick={handlePrint}
                            >
                              <i className="fas fa-print me-1" /> Print
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleSaveQuotation}
                              disabled={isSaving}
                              style={{ background: "#4f46e5", borderColor: "#4f46e5", padding: "8px 24px" }}
                            >
                              {isSaving ? (
                                <>
                                  <i className="fas fa-spinner fa-spin me-1" /> Saving...
                                </>
                              ) : (
                                <>
                                  <i className="fas fa-save me-1" /> Save Quotation
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <UserFooter />
        </div>
      </div>

      {showGenModal && (
        <QuotationGenerateFromPOModal
          onClose={() => setShowGenModal(false)}
          onSuccess={(newQuote) => {
            toast.success(`Quotation ${newQuote.quoteNumber} generated from PO!`);
            navigate(`/quotations/${newQuote.id}`);
          }}
        />
      )}
    </>
  );
};

export default CreateQuotation;
